import React from 'react';
import './GoldenBannerFullScreenImage.css'; 
import goldenImage from '../../../assets/GoldenBanner.png'; 

const GoldenBannerFullScreenImage = () => {
  return (
    <a href="/golden" className="full-screen-link">
    <img
      src={goldenImage} 
      alt="FullScreenImage"
      className="full-screen-image"
    />
  </a>
  );
};

export default GoldenBannerFullScreenImage;
